/**
 * Regex for Address and Landmark
 * @param {String} val Accept only string
 * @returns A string value that does not contain **Hindi** and some **&\%#;** special characters.
 */
export const RegexAddressLandmark = val => /^[A-Za-z0-9 ()\[\]_{}\-"',.\/$<>@!:?|*~`^+=]+$/.test(val);
export const RegexYouTubeLink = val => /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/.test(val);
